import {useTheme} from '@mui/material';

import {QueryParamsEnum} from 'presentation/constants';
import {useIsAdvanceDiagnosticsExamsJourney} from 'presentation/modules/booking/exam/hooks/useIsAdvanceDiagnosticsExamsJourney';
import {getExamStepPosition} from 'presentation/modules/booking/exam/utils/getExamStepPosition';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useMediaQueries, useQueryParams} from 'presentation/pages/private/hooks';
import {UseExamDuplicityDialogProps} from './types';
import {useExamOrientationsInfoStore} from '../../../ExamOrientationsDialog/store/useExamOrientationsInfoStore';

export function useExamDuplicityDialog({scheduledBooking}: UseExamDuplicityDialogProps) {
	const {isManualLocation} = useBookingStore(state => state.bookingData);
	const setBookingData = useBookingStore(state => state.setBookingData);
	const examOrientationInfo = useExamOrientationsInfoStore(state => state.examOrientationInfo);
	const setActiveBookingFlowStep = useBookingFlowStepsStore(state => state.setBookingStep);
	const isAdvanceDiagnosticsExamsJourney = useIsAdvanceDiagnosticsExamsJourney();
	const {isMobile} = useMediaQueries();
	const {colors} = useTheme();
	const {setSearchParams} = useQueryParams();

	const getNextStep = () => {
		const {DISTRICT_STEP, UNIT_STEP, PROFESSIONAL_STEP} = getExamStepPosition({
			isManualLocation,
		});

		if (isAdvanceDiagnosticsExamsJourney) return PROFESSIONAL_STEP;

		return isManualLocation ? DISTRICT_STEP : UNIT_STEP;
	};

	async function handleSwapSpecialty() {
		setActiveBookingFlowStep(getNextStep());

		setBookingData(prev => ({
			...prev,
			specialtyCode: scheduledBooking.specialtyCode,
			subSpecialtyCode: '',
			specialtyName: scheduledBooking.specialtyName,
			procedureCode:
				examOrientationInfo.code === scheduledBooking.specialtyCode
					? examOrientationInfo.procedureCode
					: prev.procedureCode,
			bookingType: scheduledBooking.bookingType,
			bookingNumber: scheduledBooking.bookingNumber,
			isRebooking: true,
			isScheduleScript: false,
			...(!isAdvanceDiagnosticsExamsJourney && {
				districtName: undefined,
				citiesNames: undefined,
				hasGeoDistrictsFilter: false,
			}),
		}));

		setSearchParams(prev => {
			prev.delete(QueryParamsEnum.SEARCH_QUERY);
			return prev;
		});
	}

	return {
		handleSwapSpecialty,
		colors,
		isMobile,
	};
}
